import whyDidYouRender from './whyDidYouRender'
import defaultNotifier from './defaultNotifier'

whyDidYouRender.defaultNotifier = defaultNotifier
export default whyDidYouRender
